export default __webpack_public_path__ + "static/media/choose-access.842a4cf8.svg";